import { Component } from "@angular/core";
import { LINK_PAGES } from "src/constants/param-constants";

@Component({
  standalone: true,
  selector: "app-terms",
  template: ""
})
export class TermsComponent {
  constructor() {
    window.open(`${LINK_PAGES.TERMS_AND_CONDITIONS}`, '_top');
  }
}
